import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Functional component that initializes the footer of the form.
 *
 */
const Footer = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <footer className="container footer-container">
                <div className="text-align-center" id="footer-relative-support">
                    <hr className="gray-hr-2" />
                    <a href="https://www.aanekoskenenergia.fi/asiakaspalvelu/">{t('helpFooter')}</a>
                </div>
            </footer>
        </Fragment>
    );
};

export default Footer;
